import httpClient from "../axiosBase/axiosHandler";

export const requestNewTerminal = (payload) => {
  const response = httpClient.post("/terminals/", payload);
  return response;
};

export const fetchAllTerminals = (queries) => {
  const response = httpClient.get(`/terminals/${queries}`);
  return response;
};

export const fetchPendingRequest = () => {
  const response = httpClient.get("/terminals/request-list/");
  return response;
};

export const fetchTerminalDetails = (id) => {
  const response = httpClient.get(`/terminals/${id}/`);
  return response;
};

export const resetTerminalCredentials = (id) => {
  return httpClient.post(`/terminals/${id}/reset-cashier/`, { id });
};

export const createTerminals = (data) => {
  return httpClient.post("/terminals/create-terminal/", data);
};

export const updateTerminals = ({ id, data }) => {
  return httpClient.patch(`/terminals/${id}/update-terminal/`, data);
};

export const deleteTerminals = ({ id }) => {
  return httpClient.delete(`/terminals/${id}/delete-terminal/`);
};

export const createTerminalPaymentSession = ({ id, data }) => {
  return httpClient.post(`/terminals/${id}/payment/`, data);
};

export const retryTerminalPaymentSession = ({ id, data }) => {
  return httpClient.post(`/terminals/${id}/payment/retry/`, data);
};

export const cancelTerminalPaymentSession = ({ id, data }) => {
  return httpClient.post(`/terminals/${id}/payment/cancel/`, data);
};

export const getTerminalPaymentSession = ({
  terminal_id,
  transaction_id,
  hitThirdParty = false,
}) => {
  const url = hitThirdParty
    ? `/terminals/${terminal_id}/payment/fetch/?transaction_id=${transaction_id}`
    : `/terminals/${terminal_id}/payment/get/?transaction_id=${transaction_id}`;
  return httpClient.get(url);
};

export const createInterwitchAccount = (data) => {
  return httpClient.post("/company/create-interswitch-account/", data);
};

export const updateInterwitchAccount = ({ data, id }) => {
  return httpClient.patch(`/company/${id}/update-interswitch-account/`, data);
};

export const getInterwitchAccounts = (queries = "") => {
  return httpClient.get(`/company/interswitch-account/${queries}`);
};

export const deleteInterwitchAccount = ({ id }) => {
  return httpClient.delete(`/company/${id}/delete-interswitch-account/`);
};

export const testTerminalConnection = ({ id, data }) => {
  return httpClient.post(`/terminals/${id}/validate-connection/`, data);
};

export const createTerminalBusinessAccount = (data, path) => {
  return httpClient.post(path, data);
};

export const getTerminalBusinessAccount = (path) => {
  return httpClient.get(path);
};

export const getOpayMerchantIndustries = () => {
  return httpClient.get("/company/opay-merchant-industries/");
};
